// client/src/api/client.js
import axios from "axios";

console.log("My API URL is:", process.env.REACT_APP_API_URL);
const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Request Interceptor to append the security shield token dynamically
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => Promise.reject(error),
);

// Response Interceptor to globally handle unauthorized or expired sessions
API.interceptors.response.use(
  (response) => response,
  (error) => {
    // 💡 Fix: Handle both 401 (Expired/Unauthenticated) and 403 (Forbidden) actions cleanly
    if (error.response?.status === 403 || error.response?.status === 401) {
      console.warn(
        "⚠️ Authentication profile invalid or session expired. Clearing local store.",
      );
      localStorage.removeItem("token");

      // Optional: Force a window redirect to login view frame if not on a login path
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

/**
 * Wrapper services for optimized query synchronization across backend servers
 */
export const employeeService = {
  // 👥 HR/Admin account creation mapping
  createEmployee: async (payload) => {
    const response = await API.post("/auth/register", payload);
    return response.data;
  },

  // 💡 Path Fix: Aligned straight to GET /api/employees/me
  getMyProfile: async () => {
    const response = await API.get("/employees/me");
    return response.data;
  },

  // 💡 Path Fix: Standardized to match GET /api/employees/:employeeId
  getById: async (id) => {
    const response = await API.get(`/employees/${id}`);
    return response.data;
  },

  // 💡 Path Fix: Standardized to match paginated query scopes on GET /api/auth/employees
  getAllEmployees: async (page = 1, limit = 30) => {
    const response = await API.get(
      `/auth/employees?page=${page}&limit=${limit}`,
    );
    return response.data;
  },

  // 👥 Update localized user configurations
  updateProfile: async (id, updatedData) => {
    const response = await API.patch(`/employees/${id}`, updatedData);
    return response.data;
  },

  // 📝 Registers sheet source tracks safely
  registerEmployeeSheet: async (payload) => {
    const response = await API.post("/auth/register-employee-sheet", payload);
    return response.data;
  },
};

export default API;
